import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_REQUEST]: isLoading,
  [types.FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_SUCCESS]: isEnding,
  [types.FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_FAILURE]: isEnding,
});
